import { combineEpics } from 'redux-observable'
import * as auth from './auth/epics'

const modules = [
  auth,
]

//Condense to array of values...
let epics = []
modules.map((module) => {
  Object.keys(module).map((key) => {
    epics.push(module[key])
  })
})

//Would be nice if they could just take the keyed object by default.
export default combineEpics(...epics)
